import { useTranslation } from 'react-i18next';
import { cityName } from '../lib/airports';
import { formatFlightDate, formatFlightTime } from '../lib/format';
import { toFaDigits } from '../lib/jalali';

export type FlightSummary = {
  flightNumber: string;
  origin: string;
  destination: string;
  departureAt: string;
  cabin: string;
};

export function FlightSummaryCard({
  flight,
  title,
}: {
  flight: FlightSummary;
  title?: string;
}) {
  const { t, i18n } = useTranslation();
  const isFa = i18n.language.startsWith('fa');
  const number = isFa ? toFaDigits(flight.flightNumber) : flight.flightNumber;
  const titleId = `flight-summary-${flight.flightNumber}`;

  return (
    <section className="booking-panel" aria-labelledby={titleId}>
      <h2 id={titleId} className="booking-panel__title">
        {title ?? t('common.flightDetails')}
      </h2>
      <div className="flight-summary">
        <div className="flight-summary__point">
          <span className="flight-summary__city">{cityName(flight.origin, isFa)}</span>
          <span className="flight-summary__code">{flight.origin}</span>
          <span className="flight-summary__time">
            {formatFlightTime(flight.departureAt, i18n.language)}
          </span>
        </div>
        <div className="flight-result__line" aria-hidden="true" />
        <div className="flight-summary__point">
          <span className="flight-summary__city">{cityName(flight.destination, isFa)}</span>
          <span className="flight-summary__code">{flight.destination}</span>
        </div>
      </div>
      <dl className="booking-panel__facts">
        <div>
          <dt>{t('common.departureDate')}</dt>
          <dd>{formatFlightDate(flight.departureAt, isFa)}</dd>
        </div>
        <div>
          <dt>{t('common.flightNumber')}</dt>
          <dd>{number}</dd>
        </div>
        <div>
          <dt>{t('common.cabinClass')}</dt>
          <dd>{t(`common.${flight.cabin}`, { defaultValue: flight.cabin })}</dd>
        </div>
      </dl>
    </section>
  );
}
